// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"880":"fb72c2bf","966":"e6c8100b"}[chunkId] + ".chunk.css";
};